module.exports = __webpack_public_path__ + "static/img/Beats_Solo3_Wireless.17755e4c.jpg";